/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expenseCategories/grocery': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M7.591 18.548A2.18 2.18 0 005.42 20.73c0 1.2.97 2.183 2.171 2.183 1.2 0 2.183-.982 2.183-2.183 0-1.2-.982-2.182-2.183-2.182zM1.044 2.178c0 .6.49 1.092 1.09 1.092h1.092l3.929 8.283-1.473 2.662c-.797 1.463.25 3.241 1.91 3.241h12.003c.6 0 1.092-.49 1.092-1.09 0-.601-.492-1.092-1.092-1.092H7.591l1.2-2.183h8.13c.82 0 1.54-.447 1.91-1.124l3.907-7.082a1.087 1.087 0 00-.95-1.615H5.639l-.731-1.56a1.083 1.083 0 00-.982-.623h-1.79c-.6 0-1.091.491-1.091 1.092zm17.46 16.37a2.18 2.18 0 00-2.172 2.182c0 1.2.972 2.183 2.172 2.183 1.2 0 2.183-.982 2.183-2.183 0-1.2-.983-2.182-2.183-2.182z" _fill="#000" fill-rule="evenodd"/>'
  }
})
